import { CSS } from '@dnd-kit/utilities';
import { useSortable } from '@dnd-kit/sortable';
import { useAppSelectorShallow } from 'store/hooks';
import { RevampDraggableContentProps } from 'interfaces';
import TabBodyRowRevamp from 'components/setting-generator-revamp/tabs-revamp/tab-body-row-revamp';
import { ACTIVITY_TYPES } from 'constants/general';
import { ActivityType } from 'interfaces/common.interface';
import { getHabitRowDataProps } from 'utils/validation-error-navigation.util';

const DraggableContentRevamp = ({
  id,
  position,
  type,
  sequence_id,
  customRoutinePosition
}: RevampDraggableContentProps) => {
  const { currentSettings } = useAppSelectorShallow((state) => state.setting);

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id });

  const getActivity = (): ActivityType | null => {
    let activities: ActivityType[] | undefined;

    switch (type) {
      case ACTIVITY_TYPES.MORNING:
        activities = currentSettings.morning_activities;
        break;
      case ACTIVITY_TYPES.EVENING:
        activities = currentSettings.evening_activities;
        break;
      case ACTIVITY_TYPES.BREAKING:
        activities = currentSettings.break_activities;
        break;
      case ACTIVITY_TYPES.CUSTOM_ROUTINES:
        if (
          typeof customRoutinePosition === 'number' &&
          currentSettings.custom_routines?.[customRoutinePosition]
        ) {
          activities =
            currentSettings.custom_routines[customRoutinePosition]
              .standalone_activities;
        }
        break;
      default:
        activities = currentSettings.standalone_activities;
    }

    if (!activities) {
      return null;
    }

    const activityById = activities.find((a) => String(a.id) === id);
    if (activityById) {
      return activityById;
    }

    if (position >= 0 && position < activities.length) {
      return activities[position];
    }

    return null;
  };

  const activity = getActivity();

  if (!activity) {
    return null;
  }

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.9 : 1
  } as React.CSSProperties;

  return (
    <div
      className='w-full outline-none'
      ref={setNodeRef}
      style={style}
      data-testid={`draggable-activity-revamp-${position}`}
      {...getHabitRowDataProps(activity.id)}>
      <TabBodyRowRevamp
        activity={activity}
        position={position}
        type={type}
        sequence_id={sequence_id}
        customRoutinePosition={customRoutinePosition}
        dragListeners={listeners}
        dragAttributes={attributes}
      />
    </div>
  );
};

export default DraggableContentRevamp;
